/**
 * Users
 */

// React
import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getVariantAction,
  getCategoriesAction,
  getVariantInventoryItemsAction,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectVariant,
  makeSelectVariantFeaturesListByProductId,
  makeSelectCategoriesList,
  makeSelectCategoryLoading,
  makeSelectVariantInventoryItemsCount,
  makeSelectVariantInventoryItemsList,
} from './selectors';

// Components
import List from './components/variantInventoryList';
import Edit from './components/edit';
import Add from './components/add';
import Details from './components/variantDetail';
import Inventory from './components/inventory';
import windowSize from '../../utils/hook/useWindowResize';
import VariantMobile from './mobileView/variant';

// UI
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiKeyOutline,
  mdiFormatListBulleted,
  mdiArchiveOutline,
  mdiChatOutline,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import { Props, SelectorPropsVariant } from './interfaces';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilterHookForm';
import Can from '../../components/Can';
import useQuery from '../../utils/hook/useQuery';
import classes from './variant.module.scss';
import Bell from '../../components/Notification/Bell';
import TicketLink from '../../components/ticketLink';
// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}
const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

const Variant: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const urlParams = useParams();
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  useEffect(() => {
    getVariant();
    // getCategories();
    setupFilters();
    getVariantInventoryItems();
  }, [filtersValues]);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const getVariantInventoryItems = () => {
    const { page, size } = filtersValues;
    const variantId = urlParams.variantId;
    const warehouseId = urlParams.warehouseId;
    props.variantInventoryItemsDispatch({
      ...removeEmptyValueObject(filtersValues),
      skuId: { equals: variantId },
      warehouseId: { equals: warehouseId },
      status: { equals: 'LOCATED' },
      page,
      size,
    });
  };

  useEffect(() => {
    setupFilters();
  }, [props.categoryLoading]);
  // const getCategories = () => {
  //   const {page, size} = filtersValues;
  //   const {partnerId} = props.match.params;
  //   props.categoriesDispatch({
  //     ...removeEmptyValueObject(filtersValues),
  //     partnerId: {equals: partnerId},
  //     page,
  //     size,
  //   });
  // };

  const getVariant = () => {
    const { page, size } = filtersValues;
    const { partnerId } = props.match.params;
    props.variantDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: { equals: partnerId },
      id: urlParams.variantId,
      page,
      size,
    });
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'productName.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'productCategory.in',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'Category',
          },
          {
            type: 'input',
            id: 'productCode.contains',
            label: 'کد کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'productName.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'productCategory.in',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'Category',
          },
          {
            type: 'input',
            id: 'productCode.contains',
            label: 'کد کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
        ]);
      },
    });
  };

  const handleDisableUser = async () => {
    const body = props.variantFeaturesList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: { ...body, status: 'SUSPENDED' },
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  return isMob ? (
    <VariantMobile {...props} />
  ) : (
    <div className={classes.root}>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <div className={classes.headerBox}>
          <Typography variant="h6" component="h2">
            {` جزئیات تنوع کالا`} {` `} {props.variant.productName} {'تنوع'}{' '}
            {` `}
            {props.variant.id}
          </Typography>
        </div>
        <Grid item container xs={12} sm={4} className={classes.filterContainer}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'productName.contains',
              placeholder: 'نام کالا',
            }}
            filterValues={filtersValues}
          />
          <TicketLink />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Details variant={props.variant} />
          <Grid item xs={12}>
            <Card className={classes.card} style={{ marginTop: '18px' }}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    ویژگی‌های تنوع کالا
                  </Typography>
                }
              />

              <CardContent style={{ margin: '15px 0  0', padding: '20px' }}>
                <Grid container item>
                  {props.variantFeaturesList?.map((field, index) => {
                    return (
                      <Grid item xs={12} sm={12} lg={12}>
                        <div className={classes.item}>
                          <span className={classes.label}>{field.key}</span>
                          <span>{field.value}</span>
                        </div>
                      </Grid>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid item xs={12} md={9} style={{ marginTop: '10px' }}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست آیتم‌های انبار
                  {`  `}
                  {props.variant.productName}
                </Typography>
              }
            />

            <CardContent style={{ margin: '15px 0  0', padding: '0' }}>
              <Grid spacing={4} container>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.productVariantInventoryItemsList && (
                    <List
                      data={props.productVariantInventoryItemsList}
                      handleOpenConfirmDisable={handleOpenConfirmDisable}
                      handleOpen={handleOpen}
                      changeStatus={handleOpenConfirmUpdateState}
                    />
                  )
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${props.variantFeaturesList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {`بله`}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${props.variantFeaturesList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.variantFeaturesList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.variantFeaturesList.find(
                product => product.id === id
              )}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorPropsVariant>({
  variant: makeSelectVariant(),
  categoriesList: makeSelectCategoriesList(),
  variantFeaturesList: makeSelectVariantFeaturesListByProductId(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  categoryLoading: makeSelectCategoryLoading(),
  error: makeSelectError(),
  productVariantInventoryItemsList: makeSelectVariantInventoryItemsList(),
  productVariantInventoryItemsListCount: makeSelectVariantInventoryItemsCount(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    variantDispatch: (payload: Object) => dispatch(getVariantAction(payload)),
    categoriesDispatch: (payload: Object) =>
      dispatch(getCategoriesAction(payload)),
    variantInventoryItemsDispatch: (payload: Object) =>
      dispatch(getVariantInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Variant);
